jQuery(function($) {
	$( document ).ready( function() {
		const overlayClass = 'is-open';

		/**
		 * Open panel with animation
		 */
		function openPanel( panelId ) {
			const $panel = $( '#' + panelId );
			const $overlay = $( '[data-overlay="' + panelId + '"]' );

			if ( ! $panel.length || ! $overlay.length ) {
				return;
			}

			// Prevent body scroll
			$( document.body ).css( 'overflow', 'hidden' );

			// Add active class to trigger animations
			$overlay.addClass( overlayClass );
			$panel.addClass( overlayClass );

			// Set accessibility attributes
			$panel
				.attr( 'role', 'dialog' )
				.attr( 'aria-modal', 'true' )
				.focus();
		}

		/**
		 * Close panel with animation
		 */
		function closePanel( panelId ) {
			const $panel = $( '#' + panelId );
			const $overlay = $( '[data-overlay="' + panelId + '"]' );

			if ( ! $panel.length || ! $overlay.length ) {
				return;
			}

			// Restore body scroll
			$( document.body ).css( 'overflow', '' );

			// Remove active class to trigger animations
			$overlay.removeClass( overlayClass );
			$panel.removeClass( overlayClass );

			// Clean up accessibility attributes
			$panel
				.removeAttr( 'role' )
				.removeAttr( 'aria-modal' );
		}

		/**
		 * Extract panel ID from trigger
		 * Handles both formats: "panel-123" and "#panel-123"
		 */
		function getPanelId( trigger ) {
			let panelId = trigger;
			if ( panelId.startsWith( '#' ) ) {
				panelId = panelId.substring( 1 );
			}
			return panelId;
		}

		/**
		 * Handle trigger button clicks
		 * Supports both data-overlay-trigger and data-overlay attributes
		 */
		$( document ).on( 'click', '[data-overlay-trigger], [data-overlay].is-modal-button', function( e ) {
			e.preventDefault();
			
			// Get panel ID from either attribute
			let panelId = $( this ).attr( 'data-overlay-trigger' );
			if ( ! panelId ) {
				panelId = $( this ).attr( 'data-overlay' );
			}
			
			if ( panelId ) {
				panelId = getPanelId( panelId );
				openPanel( panelId );
			}
		} );

		/**
		 * Handle close button clicks
		 */
		$( document ).on( 'click', '[data-overlay-close]', function( e ) {
			e.preventDefault();
			const panelId = $( this ).attr( 'data-overlay-close' );
			closePanel( panelId );
		} );

		/**
		 * Handle overlay clicks (close panel)
		 */
		$( document ).on( 'click', '.wp-block-jormi-drawer__overlay.is-open', function( e ) {
			const panelId = $( this ).attr( 'data-overlay' );
			closePanel( panelId );
		} );

		/**
		 * Handle Escape key
		 */
		$( document ).on( 'keydown', function( e ) {
			if ( e.key === 'Escape' || e.keyCode === 27 ) {
				const $openPanels = $( '[data-overlay-panel].is-open' );
				$openPanels.each( function() {
					const panelId = $( this ).attr( 'id' );
					closePanel( panelId );
				} );
			}
		} );
	} );
});